<div [ngTemplateOutlet]="selected ? selected.content : null"></div>